import type { LegalSection } from "../../content/legal";

export function PolicySectionList({ sections }: { sections: LegalSection[] }) {
  return (
    <div className="space-y-6">
      {sections.map((section) => (
        <section
          key={section.title}
          className="rounded-[1.75rem] border border-black/10 bg-white/70 p-6"
        >
          <h2 className="text-xl font-bold text-brand-ink tracking-[-0.02em]">{section.title}</h2>
          <div className="mt-4 space-y-3">
            {section.body.map((paragraph) => (
              <p key={paragraph} className="text-sm text-brand-muted leading-relaxed max-w-[90ch]">
                {paragraph}
              </p>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
